import { TThunkAction } from '../../types/redux';
import {
  fetchGetMarketTrand,
  IGetMarketTrandResponse200,
  IGetMarketTrandResponse400,
} from '../../repositories/valuation-offer-history/v1/get-market-trand';
import { selectHouseId } from '../../selectors/filters';
import { BadRequestError } from '@cian/valuation-utils-component';
import { getMarketTrand, setMarketTrandLoading } from './actions';
import { IMarketTrand } from '../../types/redux/marketTrand';
import { selectPeriod, selectRoomsCount } from '../../selectors/marketTrend';

export const getMarketTrend = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const { httpApi, logger } = context;

  const state = getState();
  const houseId = selectHouseId(state) as number;
  const roomsCount = selectRoomsCount(state);
  const period = selectPeriod(state);

  try {
    dispatch(setMarketTrandLoading(true));

    const response = await fetchGetMarketTrand<IGetMarketTrandResponse200, IGetMarketTrandResponse400>({
      httpApi,
      parameters: {
        realtyId: houseId,
        roomsCount,
        period,
      },
    });

    if (response.statusCode !== 200) {
      throw new BadRequestError({
        domain: 'getMarketTrend.ts',
        message: response.response.message as string,
      });
    }

    dispatch(getMarketTrand(response.response as IMarketTrand['marketTrendData']));
  } catch (err) {
    logger.error(err);
  } finally {
    dispatch(setMarketTrandLoading(false));
  }
};
